import { apiClient } from '../../client';
import { BranchData } from '../../../../contract/dtos';
import { getBranches, getBasicBranchData, GetBasicBranchDataParams } from '../../shared/branch';

// Combined params for create/update
interface BranchMutationParams {
  entityType: 'request' | 'tenant';
  entityId: string | number;
  branchData: BranchData;
  branchId?: string | number; 
}

// Params for getting branches
interface GetBranchesParams {
  tenant_id: number;
  component_id: number;
  branches_ids?: string;
  name?: string;
  city_id?: string;
  city_name?: string;
  area_id?: string;
  area_name?: string;
  contact_person_name?: string;
  contact_person_email?: string;
  contact_person_mobile?: string;
  size?: number;
  page?: number;
  sort?: string;
}

// Export parameter types for better type support
export type { BranchMutationParams, GetBranchesParams, GetBasicBranchDataParams };

// ⚪⚪ to update branch pass the branchId ⚪⚪
export const branchQueries = {
  queries: {
    getBranches: (params: GetBranchesParams) => ({
      queryKey: ['branches', params],
      queryFn: () => getBranches(params)
    }),
    getBranchesForDropdown: (params: GetBranchesParams) => ({
      queryKey: ['branches-dropdown', params],
      queryFn: () => getBranches({ ...params, size: 1000, page: 0 })
    }),
    getBasicBranchData: (params: GetBasicBranchDataParams) => ({
      queryKey: ['branches-basic-data', params],
      queryFn: () => getBasicBranchData(params)
    })
  },
  mutations: {
    createOrUpdate: (params: BranchMutationParams) => ({
      mutationKey: ['branch-create-update', params.entityType, params.entityId],
      mutationFn: async () => {
        const endpoint = `/corporate/v1/${params.entityType}/${params.entityId}/branch${params.branchId ? `/${params.branchId}` : ''}`;
        const response = await apiClient.put(endpoint, params.branchData);
        return response.data;
      }
    })
  }
}; 